import React from 'react';

import { useField } from 'formik';

import { twMerge } from 'tailwind-merge';

import Typography from 'components-new/typography/typography';
import TextArea from 'components-new/text-area/text-area';

interface TextAreaFieldProps
  extends React.DetailedHTMLProps<
    React.TextareaHTMLAttributes<HTMLTextAreaElement>,
    HTMLTextAreaElement
  > {
  name: string;
  className?: string;
  textareaClassName?: string;
  typographyClassName?: string;
}

const TextAreaField: React.FC<TextAreaFieldProps> = (props) => {
  const {
    name,
    typographyClassName,
    className,
    textareaClassName,
    ...texareaFieldProps
  } = props;
  const [field, meta] = useField({ name, type: 'text' });

  return (
    <div className={twMerge('flex flex-col gap-y-1 w-full', className)}>
      <TextArea
        {...field}
        {...texareaFieldProps}
        className={textareaClassName}
      />
      {meta.error && meta.touched && (
        <Typography
          as="p"
          variant="body-medium"
          className={twMerge('text-destructive', typographyClassName)}
        >
          {meta.error}
        </Typography>
      )}
    </div>
  );
};

export default TextAreaField;
